var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefit2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 30,
    viewBox: "0 0 54 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.382 6.40319C26.8923 6.57055 29.2911 7.23996 31.4666 8.24408C33.4191 6.7379 35.6505 5.06437 38.3281 3.05613C33.9769 0.824754 29.1237 -0.235149 24.382 0.0437726C17.3532 0.434263 10.7148 3.66976 6.30788 8.69036C2.62611 12.7626 0.450517 18.0064 0.00424136 23.2501C-0.051543 23.8637 0.450517 24.4216 1.06415 24.4216C1.5662 24.4216 2.01248 24.0311 2.12405 23.5848C3.12817 18.8989 5.63847 14.6035 9.15288 11.5911C13.3925 7.79781 19.0267 6.0127 24.382 6.40319Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2452 8.18832C43.0696 11.0333 41.2287 13.4878 39.6667 15.5519C41.1729 18.0064 42.0655 20.7398 42.3444 23.4733C42.4002 23.9753 42.8465 24.4216 43.4043 24.4216H51.9393C52.6087 24.4216 53.1108 23.808 52.9992 23.1385C51.9393 17.4485 49.2059 12.149 45.2452 8.18832Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1303 4.28341C44.5766 3.66979 43.8514 2.94459 43.2377 3.39086C38.6076 6.90528 30.5189 12.9858 25.9446 16.556C25.4425 16.4444 24.9404 16.3328 24.3826 16.3328C20.645 16.3886 17.5769 19.4568 17.5769 23.1943C17.5769 26.9319 20.5893 30 24.3826 30C28.1759 30 31.1883 26.9877 31.1883 23.1943C31.1883 22.6365 31.1325 22.1344 30.9652 21.6324C34.5354 17.0023 40.6159 8.9693 44.1303 4.28341Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit2);
export default __webpack_public_path__ + "static/media/benefit-2.54396c06e1d39a1a80dcba514c324e3c.svg";
export { ForwardRef as ReactComponent };